<div class="bg-white">
  <div class="row">
    <div class="card-header bg-very-light-gray small-12 column">
      <div id="toggle-linear" class="card-title card-padding flex margin-all">
        <h2>{{'assistance.duplicate-assistance' | translate}}</h2>
      </div>
    </div>
    <div class="bg-white padding-v margin-t">
      <label class="small-12 columns margin-t-l margin-b-l">
        <input (keyup)="keyUp.next($event)" class="input-large" type="text" placeholder="{{'assistance.duplicate.find-account' | translate }}" [value]="selectedAccount ? selectedAccount.name : ''" required="">
      </label>
      <div class="small-12 columns list condensed" style="height:160px; overflow-y:scroll;">
        <div *ngIf="filteredAccounts && !showSpinnerResearch ">
          <div *ngIf="filteredAccounts.length > 0" class="small-12 columns list condensed" style="height:160px; overflow-y:scroll;">
            <a *ngFor="let account of filteredAccounts" class="item" (click)="selectAccount(account)">{{account.name}}</a>
          </div>
          <div *ngIf="filteredAccounts.length === 0" class="list condensed" style="height:160px; overflow-y:scroll;">
            {{'assistance.duplicate.no-account-found' | translate }}
          </div>
        </div>
        <div *ngIf="showSpinnerResearch" class="widget-spinner padding-v-l">
          <div></div>
        </div>
      </div>
    </div>
    <div class="small-8 columns margin-t-l margin-b-l">
      {{message()}}
    </div>
    <div class="small-4 columns text-right margin-t-l margin-b-l">
      <input type="submit" value="Enregistrer" (click)="duplicate()" class="button success margin-r-xs">
    </div>
  </div>
</div>
